import { isValidNumber, parse, format } from 'libphonenumber-js'
import R from 'ramda'

const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
const numberRegex = /^[0-9]+$/
const alternatePhonePrefixRegex = /^00/

export const validateEmail = email => {
  return emailRegex.test(email)
}

export const validatePhoneNumber = phoneNumber => {
  if (alternatePhonePrefixRegex.test(phoneNumber)) {
    // begins with 00, should use a + instead
    phoneNumber = phoneNumber.replace(alternatePhonePrefixRegex, '+')
  }

  return isValidNumber(format(parse(phoneNumber), 'International'))
}

export const validateNumber = n => {
  let nAsString = typeof n === 'number' ? n.toString() : n
  return numberRegex.test(nAsString)
}

export const validadeMinLength = (value, min) => {
  return value.length >= min
}

export const validadeMaxLength = (value, max) => {
  return value.length <= max
}

export const filledForm = value => {
  return value.length > 0
}

export const validateInput = (name, value, errors) => {
  const newErrors = Object.assign({}, errors)
  switch (name) {
    case 'email':
      newErrors[name] = validateEmail(value) ? '' : 'The email is not valid'
      return newErrors
    case 'phoneNumber':
      newErrors[name] = validatePhoneNumber(value)
        ? ''
        : 'The field is not a phone number'
      return newErrors
    case 'usableArea':
    case 'area':
    case 'yield':
    case 'noRooms':
    case 'price':
      newErrors[name] = validateNumber(value)
        ? ''
        : 'The field must be a number'
      return newErrors
    default:
      newErrors[name] =
        value && !R.isEmpty(value) ? '' : 'This field is required'
      return newErrors
  }
}

export const validateForm = (values, errors) => {
  const requiredFields = document.querySelectorAll('[required]')
  let newErrors = R.clone(errors)
  let valid = true
  requiredFields.forEach(field => {
    const fieldIdentifier = field.name || field.id
    newErrors = validateInput(
      fieldIdentifier,
      values[fieldIdentifier],
      newErrors
    )
    valid = valid && !newErrors[fieldIdentifier]
  })
  return {
    valid: valid,
    errors: newErrors
  }
}



// WEBPACK FOOTER //
// ./src/Utils/Validations.js